import { ScreenProps } from "@components-common/types";
import { Page, PageTable } from "@components-common/layouts";
import { table_defaults } from "../tables/templates";

export const index: any = {
  route: {} as any,
  cat: 'screen',
  type: 'index',
  view: {
    type: 'index',
    cat: "page",
    Component: Page,
    props: {
      title: 'INDEX_TITLE_NOT_SET',
      table: {
        cat: 'table',
        type: 'index'
      }
    }
  }
};
export const c = 0;
